module.exports = __webpack_public_path__ + "img/banner-2.77e73406.jpg";